import { ViewState } from '@transcend-io/airgap.js-types';

export const TRANSCEND_LOAD_EVENT_NAME = 'transcend-loaded';
export const TRANSCEND_VIEW_STATE_CHANGE_EVENT_NAME = 'view-state-change';
export const TRANSCEND_CONSENT_CHANGE_EVENT_NAME = 'consent-change';
export const COOKIE_EXPIRATION_PERIOD_MINUTES = 1440;
export const DEFAULT_TRANSCEND_VIEW_STATE =
  ViewState.AcceptOrRejectAllOrMoreChoices;

export const HIDDEN_CONSENT_REGIMES = ['Unknown', 'US_OTHER', 'ROW'];
